import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bag-2, luggage, buggage "><path d="M8.75195 5.75C8.75195 5.05964 9.3116 4.5 10.002 4.5H14.002C14.6923 4.5 15.252 5.05964 15.252 5.75V7H16.75V21H18.25C20.3211 21 22 19.3211 22 17.25V10.75C22 8.67893 20.3211 7 18.25 7H16.752V5.75C16.752 4.23122 15.5207 3 14.002 3H10.002C8.48317 3 7.25195 4.23122 7.25195 5.75V7H8.75V21H15.25V7H8.75195V5.75Z" fill="currentColor"/><path d="M5.75 7H7.25V21H5.75C3.67893 21 2 19.3211 2 17.25V10.75C2 8.67893 3.67893 7 5.75 7Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBag2;
